import Controller from '@ember/controller';

export default class LegacyLicenseController extends Controller {
  get license() {
    return this.model;
  }
}
